export default function Home() {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8">
      <h1 className="text-3xl font-bold text-foreground mb-4">Welcome to Pliable</h1>
      <p className="text-muted-foreground text-center max-w-md">
        Your low-code data platform for analytics and AI. Get started by exploring your data or chatting with Ellie.
      </p>
    </div>
  );
}
